import { Select, SelectOption } from '@bloomfieldrobotics/canopy';
import { useEffect, useMemo } from 'react';
import { useCustomers } from '../../../services/entities/hooks/useCustomers';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
type CustomerDropdownProps = {
  value: string;
  onChange: (value: string) => void;
  fullWidth?: boolean;
  extraOptions?: SelectOption<string>[];
  hideIfOneCustomer?: boolean;
};

export const CustomerDropdown = ({
  value,
  onChange,
  fullWidth = false,
  hideIfOneCustomer = false,
  extraOptions = [],
}: CustomerDropdownProps) => {
  const { t } = useTranslation();

  const { customers, isCustomersLoading } = useCustomers();
  useEffect(() => {
    console.log(
      '👤 CustomerDropdown useEffect - customers:',
      customers?.length,
      'current value:',
      value
    );
    if (customers?.length === 1) {
      if (customers.at(0)) {
        console.log('👤 Auto-selecting single customer:', customers[0].id);
        onChange(customers[0].id);
      }
    }
  }, [customers, onChange, value]);

  const customerDropdownItems = useMemo(() => {
    const hasExtraOptions = extraOptions?.length > 0;
    if (customers) {
      const customerOptions = customers.map((customer) => ({
        label: customer.name,
        value: customer.id,
      }));

      // Check if extra options are provided and append them to the customer options
      if (hasExtraOptions) {
        return [...extraOptions, ...customerOptions];
      }

      return customerOptions;
    }

    // If no customers are available, return the extra options if they exist
    return hasExtraOptions ? extraOptions : [];
  }, [customers, extraOptions]);

  if (hideIfOneCustomer && customers?.length === 1) {
    return null;
  }

  const handleChange = (newValue: string) => {
    console.log('👤 CustomerDropdown manual selection:', newValue);
    onChange(newValue);
  };

  console.log(
    '👤 CustomerDropdown render - value:',
    value,
    'isLoading:',
    isCustomersLoading,
    'options:',
    customerDropdownItems.length
  );

  return (
    <Select
      label={t('Customer')}
      options={customerDropdownItems}
      fullWidth={fullWidth}
      value={isCustomersLoading ? '' : value}
      onChange={handleChange}
      loading={isCustomersLoading}
    />
  );
};
